import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '@/layouts/MainLayout';
import LandingPage from '@/features/landing/LandingPage';

import ComingSoonPage from '@/features/coming-soon/ComingSoonPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="coming-soon" element={<ComingSoonPage />} />
        <Route path="*" element={<Navigate to="/coming-soon" replace />} />
      </Route>
    </Routes>
  );
}

